import {
    GETCUSTOMERIDANDNAMEADMINLIST_SUCCESS,
    GETCUSTOMERIDANDNAMEADMINLIST_FAILED,
    RESET_GETCUSTOMERIDANDNAMEADMINLIST,
    LOADING_GETCUSTOMERIDANDNAMEADMINLIST,
    NETWORK_ERROR_GETCUSTOMERIDANDNAMEADMINLIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETCUSTOMERIDANDNAMEADMINLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETCUSTOMERIDANDNAMEADMINLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETCUSTOMERIDANDNAMEADMINLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETCUSTOMERIDANDNAMEADMINLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETCUSTOMERIDANDNAMEADMINLIST:
            return (state = initialState);
        default:
            return state;
    }
};
